export { default } from './Spin';
